import { ModalStyled } from 'components/UI/styled/modal-styled';
import React, { useEffect, useState } from 'react';
import Col from 'react-bootstrap/esm/Col';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import { Indicacao } from 'models/indicacoes';
import { CadastroQualificado, Candidatos } from 'models/cadastro-qualificado';
import { format } from 'fecha';
import { Bolsa } from "../models/bolsa";
import {cpfMask, validaCPF} from 'utils/cpf-utils';
import {telMask} from 'utils/tel-utils';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  indicacao?: CadastroQualificado;
  onEdit: (newObj: CadastroQualificado, index: number) => void;
  index: number;
}

const EditarModal = (props: Props) => {

  const [isValidCPF, setIsValidCPF] = useState(true);
  const [candidato, setCandidato] = useState<CadastroQualificado>();
  const disabled = !isValidCPF || !candidato?.cpf || !candidato?.telefone || !candidato?.email || !candidato?.nome;
  
  useEffect(()=>{
    if(props.indicacao){
      setCandidato(props.indicacao);
      onBlurCPF(props.indicacao.cpf);
    }

  }, [props.indicacao]);

  const onCandidatoChange = (name:string, value:string) =>{
    const tmp:any = {...candidato, [name]: value};
    setCandidato(tmp);  
  }

  const onBlurCPF = (value: string) =>{
    if((value+'').length  > 10){
      if(validaCPF(value)){
        setIsValidCPF(true);
      }else{
        setIsValidCPF(false);
      }
    }
  }

  const onClickEdit = () => {
    props.onEdit(candidato!, props.index);
  }

  return (
    <ModalStyled
      show={props.isOpen}
      onHide={props.onClose}
      className="modal-md"
    >
        <ModalStyled.Header closeButton>
          <ModalStyled.Title>
            Editar Inscrição
          </ModalStyled.Title>
        </ModalStyled.Header>

        <ModalStyled.Body>
          <Container>
            <Form.Row>    
              <Col md={6}>
                <Form.Label>CPF</Form.Label>
                <Form.Control type="text" placeholder=""
                value={cpfMask(candidato?.cpf)}
                onChange={(e) => onCandidatoChange('cpf', e.target.value)}
                onBlur={(e) => onBlurCPF(e.target.value)}
                isInvalid={!isValidCPF} />
                {!isValidCPF &&
                  <p className="error-msg">CPF inválido!</p>
                }
              </Col>
              <Col md={6}>
                <Form.Label>Nome</Form.Label>
                <Form.Control type="text" placeholder=""
                  value={candidato?.nome}
                  onChange={(e) => onCandidatoChange('nome', e.target.value)}
                  />
              </Col>
            </Form.Row>
            <Form.Row>
              <Col md={6}>
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" placeholder=""
                  value={candidato?.email}
                  onChange={(e) => onCandidatoChange('email', e.target.value)}
                />
              </Col>
              <Col md={6}>
                <Form.Label>Telefone</Form.Label>
                <Form.Control type="text" placeholder=""
                  value={candidato?.telefone}
                  onChange={(e) => onCandidatoChange('telefone', e.target.value)}
                />
              </Col>
            </Form.Row>

            <div className="talign-right">
              <Button variant="primary" type="button" disabled={disabled} onClick={() => onClickEdit()} >Editar</Button>
            </div>

          </Container>
        </ModalStyled.Body>
    </ModalStyled>
  );
}

export default EditarModal;